<template>
	<div class="image-list flex-start flex-center flex-wrap">
		<div class="image-item" v-for="(value, key) in list" :key="key">
			<el-image class="image-show" :src="value" fit="contain" :preview-src-list="list"/>
		</div>
	</div>
</template>

<script>
	export default {
		name:"showBoth",
		props:{
			list:{
				type: Array,
				required: false,
				default: []
			}
		},
		methods:{
		}
	}
</script>

<style scoped lang="scss">
.image-list{
	width: 100%;
	.image-item{
		// width: 186rpx;
		// height: 186rpx;
		position: relative;
		margin: 10px;
		.image-show{
			width: 186px;
			height: 186px;
			border-radius: 16px;
			object-fit: cover;
		}
		.video-show{
			width: 402px;
			height: 186px;
			border-radius: 16px;
		}
	}
	.image-video{
		
	}
}
.image-item:nth-child(3n+3){
	margin-right: 0px;
}
</style>